/**
 * @generated SignedSource<<ed3172c631221d30d3f1366982b9cc8a>>
 * @relayHash 3d89323afb1137acce0d20d056dd1c17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f1ecfc7a34867858bd95b303bf33163c2d02cb84969a8c6c8b7dc13cd9c2d14a

import type { ConcreteRequest } from 'relay-runtime';
export type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables = Record<PropertyKey, never>;
export type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data = {
  readonly orgDefaultClassificationLevelId: string | null;
};
export type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery = {
  response: useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data;
  variables: useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "orgDefaultClassificationLevelId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3d89323afb1137acce0d20d056dd1c17",
    "id": "f1ecfc7a34867858bd95b303bf33163c2d02cb84969a8c6c8b7dc13cd9c2d14a",
    "metadata": {},
    "name": "useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery",
    "operationKind": "query",
    "text": "query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery{orgDefaultClassificationLevelId}"
  }
};
})();

(node as any).hash = "ca879e2beb9cc23922da0259b6f540ab";

export default node;
